/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Background_NameInputs */

const en_marketing_feature_background_name = /** @type {(inputs: Marketing_Feature_Background_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background work`)
};

const es_marketing_feature_background_name = /** @type {(inputs: Marketing_Feature_Background_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo en segundo plano`)
};

const fr_marketing_feature_background_name = /** @type {(inputs: Marketing_Feature_Background_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement en arrière-plan`)
};

/**
* | output |
* | --- |
* | "Background work" |
*
* @param {Marketing_Feature_Background_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_background_name = /** @type {((inputs?: Marketing_Feature_Background_NameInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Background_NameInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_background_name(inputs)
	if (locale === "es") return es_marketing_feature_background_name(inputs)
	return fr_marketing_feature_background_name(inputs)
});